import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {KeyInPasscodeActions} from './key-in-passcode.actions';
import {Router} from '@angular/router';
import {GlobalService} from '../global.service';
import {ApiService} from '../api.service';
import {environment} from '../../environments/environment';

declare var $: any;

@Component({
    selector: 'app-key-in-passcode',
    templateUrl: './key-in-passcode.component.html',
    styleUrls: ['./key-in-passcode.component.scss']
})
export class KeyInPasscodeComponent implements OnInit {
    keyInPasscodeStore: any;
    passcode: any;
    subscription: any;
    data_check_domain: any;
    checkUrlLoading: any = true;
    anyError: boolean;
    anyErrorVoucher: boolean;
    anyErrorPasscode: boolean;
    loading: boolean;
    voucher:any;
    has_passcode:boolean;
    has_voucher:boolean;
    check_passcode: boolean;
    check_voucher: boolean;

    constructor(
            private globalService: GlobalService,
            private router: Router,
            private store: Store<any>,
            private apiService: ApiService,
            private cd: ChangeDetectorRef,
            private keyInPasscodeActions: KeyInPasscodeActions) {
        
        //input passcode and check value
        this.subscription = this.store
                .select('keyInPasscode')
                .subscribe(store => {
                    // show message error
                    this.keyInPasscodeStore = store;
                    if (!this.checkUrlLoading) {
                        //check if susccess redirect and save to session
                        if (this.keyInPasscodeStore.success || this.globalService.getSession('viewPlan')) {
                            if (!this.globalService.getSession('viewPlan')) {
                                this.globalService.setSession('viewPlan', this.keyInPasscodeStore.campPaign);
                            }
                            this.router.navigateByUrl('/view-plans');
                            // console.log(sessionStorage)
                        }
                    }
                });
    }
    
    
    ngOnInit() {
        
        /**Loading when check passcode */
        $(document).on('ready', function () {
            setTimeout(() => {
                $('.loading_check').css({
                    'opacity': '0', 'z-index': '-1'
                });
            }, 0);
        });
        
        
        /** valueParam get from enviroment*/
        let valueParam = encodeURIComponent(environment.linkCheckUrl);
        this.data_check_domain = valueParam;
        
        
        if (!this.data_check_domain) {
            
            //input passcode and check value
            this.subscription = this.store
                    .select('keyInPasscode')
                    .subscribe(store => {
                        // show message error
                        this.keyInPasscodeStore = store;
                        
                        //check if susccess redirect and save to session
                        if (store.success || this.globalService.getSession('viewPlan')) {
                            if (!this.globalService.getSession('viewPlan')) {
                                this.globalService.setSession('viewPlan', store.campPaign);
                            }
                            this.router.navigateByUrl('/view-plans');
                        }
                    });
            //end check passcode
            
        }
        //if url != null -> call api
        else {
            this.apiService.checkDomain(this.data_check_domain).subscribe(res => {
                //if success
                if (res.success) {
                    this.checkUrlLoading = false;
                    // console.log(res)
                    this.globalService.setSession('data-url', this.data_check_domain);
                    this.globalService.setSession('data-organization', res.data.item.attributes.organization);
                    
                    //save id_campaign
                    this.globalService.setSession('id_campaign', res.data.item.id);
                    
                    
                    //save slider
                    this.globalService.setSession('slider_desktop', res.data.item.attributes.desktop_banner);
                    this.globalService.setSession('slider_mobile', res.data.item.attributes.mobile_banner);
                    
                    //save popup
                    this.globalService.setSession('show_popup_frontpage', res.data.item.attributes.show_popup_frontpage);
                    this.globalService.setSession('popup_frontpage', res.data.item.attributes.popup_frontpage);
                    this.globalService.setSession('link_popup_frontpage', res.data.item.attributes.link_popup_frontpage);
                    
                    this.globalService.setSession('show_popup_thankyoupage', res.data.item.attributes.show_popup_thankyoupage);
                    this.globalService.setSession('popup_thankyoupage', res.data.item.attributes.popup_thankyoupage);
                    this.globalService.setSession('link_popup_thankyoupage', res.data.item.attributes.link_popup_thankyoupage);
                    
                    this.globalService.setSession('show_popup_3rdpage', res.data.item.attributes.show_popup_3rdpage);
                    this.globalService.setSession('popup_3rdpage', res.data.item.attributes.popup_3rdpage);
                    this.globalService.setSession('link_popup_3rdpage', res.data.item.attributes.link_popup_3rdpage);
                    console.log("Show Popup Thankyou " + this.globalService.getSession('show_popup_thankyoupage'));
                    console.log("Image Popup Thankyou " + this.globalService.getSession('popup_thankyoupage'));
                    console.log("URL Popup Thankyou " + this.globalService.getSession('link_popup_thankyoupage'));
                    // passcode true
                    // if (res.data.item.attributes.has_passcode) {

                    this.has_passcode = res.data.item.attributes.has_passcode;
                    this.has_voucher = res.data.item.attributes.enable_voucher;
                    
                    if (res.data.item.attributes.has_passcode || res.data.item.attributes.enable_voucher) {
                        console.log("passcode", this.has_passcode);
                        console.log("voucher", this.has_voucher);
                        // off loading
                        $('.loading_check').css({
                            'opacity': '0', 'z-index': '-1'
                        });
                    }
                    
                    //passcode false
                    else {
                        this.sortDevice(res.data.item)
                    }
                    
                    
                    /** save data organization to session  */
                    this.store.dispatch(this.keyInPasscodeActions.updateOrganization(res.data.item.attributes.organization));
                    
                }
                //failure
                else {
                    this.router.navigateByUrl('/wrong-url');
                    // window.location.href = '/wrong-url';
                }
                 
            });
        }
        
    }
    
    
    onCheckVoucherNPassCode() {
        // this.apiService.checkDomain(this.data_check_domain).subscribe(res => {
        //     this.sortDevice(res.data.item)
        // })
        
        //this.apiService.checkDomain(this.data_check_domain).subscribe(res => {
        //  this.sortDevice(res.data.item)
        //})
        
        
        //console.log(this.store.dispatch(this.keyInPasscodeActions.checkPasscode(this.passcode + '&url=' + this.data_check_domain)));
        // this.store.dispatch(this.keyInPasscodeActions.checkPasscode(this.passcode + '&url=' + this.data_check_domain))
        let goNextStep = false;
        let dataNextStep;
        if(this.has_passcode){
            const key = this.passcode + '&url=' + this.data_check_domain
            
            this.anyError = false
            this.loading = true
            
            this.apiService.checkInPasscode(key).subscribe(data => {
                console.log("checkInPasscode",data);
                if (data.error) {
                    this.anyErrorPasscode = true
                } else {
                    // this.sortDevice(data.data.item)
                    dataNextStep = data.data.item;
                    this.check_passcode = true;
                    this.goNextStep(dataNextStep)
                }
                // this.loading = false
                // this.cd.detectChanges()
            })
        }
        console.log("goNextStep", goNextStep)
        if(this.has_voucher){
            const key = this.voucher + '&url=' + this.data_check_domain
            
            this.anyError = false
            this.loading = true
            
            this.apiService.checkVoucher(key).subscribe(data => {
                console.log("checkVoucher",data);
                if (data.error) {
                    this.anyErrorVoucher = true
                } else {
                    // this.sortDevice(data.data.item)
                    this.globalService.setSession('voucher', this.voucher);
                    dataNextStep = data.data.item;
                    this.check_voucher = true;
                    this.goNextStep(dataNextStep)
                }
                // this.loading = false
                // this.cd.detectChanges()
            })
        }
        

        this.loading = false
        this.cd.detectChanges()
    }

    goNextStep(dataNextStep){
        if(this.has_passcode == true && this.has_voucher == true){
            if(this.check_passcode == true  && this.check_voucher == true){
                this.sortDevice(dataNextStep)
            }
        }else{
            if(this.has_passcode == true && this.check_passcode == true){
                this.sortDevice(dataNextStep)
            }
            if(this.has_voucher == true && this.check_voucher == true){
                this.sortDevice(dataNextStep)
            }
        }
        
        
    }
    
    ngOnDestroy() {
        // this.subscription.unsubscribe();
    }
    
    sortDevice(res) {
        
        this.router.navigateByUrl('/view-plans');
        
        /**get all device on plans and device price lowest when device dupplicate */
        var viewPlan = res;
        
        let groupDevices = [], groupLowestPriceDevices = [], identicalIds = [];
        viewPlan.attributes.plans.forEach(plan => {
            
            groupDevices = groupDevices.concat(plan.devices);
            
            groupDevices.forEach(device => {
                if (plan.id === device.pivot.plan_id) {
                    device.plan_rebate_price = plan.rebate_price;
                }
            });
        });
        
        
        // console.log(groupDevices);
        
        groupDevices.forEach((device) => {
            if ($.inArray(device.id, identicalIds) === -1) {
                identicalIds.push(device.id);
                
                // console.log('--------------------device----------------------',device)
                
                /**Get the device with lowest price from the filtered result */
                var lowestPriceDevices;
                
                /**filter theo id */
                var result = groupDevices.filter(filterdDevice => filterdDevice.id === device.id);
                // console.log('result', result)
                
                /** lấy giá thấp nhất của result theo device_rrp_final */
                var minPriceRoot = Math.min.apply(Math, result.map(function (item) {
                    return item.device_rrp_final;
                }));
                // console.log('minPriceRoot',minPriceRoot);
                
                /**neu device_rrp_final =  minPriceRoot ==> count++ */
                var count = 0;
                
                var arrInstallment = [];
                result.forEach(item => {
                    if (item.pivot.bundle_type === 'installment') {
                        arrInstallment.push(item)
                    }
                });
                
                /** Trường hợp divice có bundle_type là installment */
                if (arrInstallment.length > 0) {
                    /** lấy giá thấp nhất của result theo installment */
                    var minPriceInstallment = Math.min.apply(Math, arrInstallment.map(function (item) {
                        return item.pivot.installment;
                    }));
                    
                    arrInstallment.forEach(item => {
                        if (item.pivot.installment == minPriceInstallment) {
                            count++;
                        }
                    });
                    arrInstallment.forEach(item => {
                        /**trường hợp bình thường (chỉ có 1 thằng giá thấp nhất) */
                        if (item.pivot.installment == minPriceInstallment && count < 2) {
                            // console.log('key < 2')
                            lowestPriceDevices = item;
                            // console.log('lowestPriceDevices 1',lowestPriceDevices)
                        } else if (item.pivot.installment == minPriceInstallment && count >= 2) {
                            // console.log('key >= 2');
                            /** filter theo device_rrp_final (sau khi filter theo id) */
                            var resultSamePrice = arrInstallment.filter(filterdDevice => minPriceInstallment == filterdDevice.pivot.installment);
                            // console.log('resultSamePrice', resultSamePrice)
                            
                            var minPlanPrice = Math.min.apply(Math, resultSamePrice.map(function (item) {
                                return item.plan_rebate_price;
                            }));
                            // console.log('minPlanPrice',minPlanPrice);
                            
                            if (item.plan_rebate_price <= minPlanPrice) {
                                lowestPriceDevices = item;
                            }
                            // console.log('lowestPriceDevices 2',lowestPriceDevices)
                        }
                    });
                } else {
                    result.forEach(item => {
                        if (item.device_rrp_final === minPriceRoot) {
                            count++;
                        }
                    });
                    
                    result.forEach(item => {
                        /**trường hợp bình thường (chỉ có 1 thằng giá thấp nhất) */
                        if (item.device_rrp_final === minPriceRoot && count < 2) {
                            // console.log('key < 2')
                            
                            lowestPriceDevices = item;
                            // console.log('lowestPriceDevices 1',lowestPriceDevices)
                        }
                        
                        /**trường hợp có > 2 thằng giá thấp nhất */
                        else if (item.device_rrp_final === minPriceRoot && count >= 2) {
                            // console.log('key >= 2');
                            
                            /** filter theo device_rrp_final (sau khi filter theo id) */
                            var resultSamePrice = result.filter(filterdDevice => minPriceRoot == filterdDevice.device_rrp_final);
                            // console.log('resultSamePrice', resultSamePrice)
                            
                            var minPlanPrice = Math.min.apply(Math, resultSamePrice.map(function (item) {
                                return item.plan_rebate_price;
                            }));
                            // console.log('minPlanPrice',minPlanPrice);
                            
                            if (item.plan_rebate_price <= minPlanPrice) {
                                lowestPriceDevices = item;
                            }
                            // console.log('lowestPriceDevices 2',lowestPriceDevices)
                            
                        }
                    });
                }
                
                
                /* Append the device to groupIdenticalDevices */
                groupLowestPriceDevices.push(lowestPriceDevices);
            }
            
        });
        
        //console.log(groupLowestPriceDevices)
        
        /** save to session */
        viewPlan.attributes.devices = groupLowestPriceDevices;
        this.globalService.setSession('viewPlan', viewPlan);
        
    }
    
    
}
